import React, { Component } from 'react';
import { Grid, WhiteSpace } from 'antd-mobile';
import $ from "jquery";
export class DetailItem extends Component {
    constructor(props) {
        super(props);
        this.state = { show: false }
    }
    onClick = (e) => {
        if (e.ksmc) {
            if (e.ksmc) {
                $("html,body").animate({
                    scrollTop: $("#"+e.ksmc).offset().top-40
                }, 500);
            }
        }
    }
    render() {
        const reportd = this.props.reportd;
        const tjjrmx = this.props.reportd.tjjrmx;
        return (
            <div className="reportitems" id="reportitems">
                <div className="sub-title">科室导航</div>
                <Grid data={reportd.tjjrmx}
                    columnNum={4}
                    hasLine={true}
                    square={false}
                    onClick={this.onClick}
                    renderItem={dataItem => (
                        <div>
                            {dataItem.ksmc}
                        </div>
                    )}
                />
                <WhiteSpace />
                <div>
                    {
                        tjjrmx === undefined ? '' :
                            tjjrmx.map((data, index) => (
                                <div key={index} id={data.ksmc} >
                                    <div className="sub-title"><span className="title">{data.ksmc}</span></div>

                                    {

                                        data.zhxm.length === 0 ? '' :
                                            data.zhxm.map((tjjrmxdata, index2) => (
                                                <div key={index2}>

                                                    <div className="sub-title2"><span className="title">{tjjrmxdata.zhxmmc}</span><span className="text">检查医生：{tjjrmxdata.zhjcys} <br></br>检查时间：{tjjrmxdata.zhjrcq}</span></div>
                                                    {
                                                        tjjrmxdata.tjxm.length === 0 ? '' :
                                                            tjjrmxdata.tjxm.map((tjxmdata, index3) => (
                                                                <div key={index3}>
                                                                    {
                                                                        tjjrmxdata.ismulti === '0' ? <div className="sub-title3">
                                                                            <span className="title">{tjxmdata.mc}</span>
                                                                            <span className="text">{tjxmdata.jg}</span>
                                                                        </div> :
                                                                            <div className="sub-title3">
                                                                                <span className="title">{tjxmdata.mc}</span>
                                                                                <span className="text">{tjxmdata.jg}:{tjxmdata.dw}<br></br>参考值：{tjxmdata.ckfw}</span>
                                                                            </div>
                                                                    }

                                                                </div>
                                                            ))
                                                    }
                                                    <div className="xj">
                                                        {tjjrmxdata.xj === '' || tjjrmxdata.xj === '未见异常' ? <span className="g">{tjjrmxdata.xj}</span> : <span className="r">{tjjrmxdata.xj}</span>}
                                                    </div>
                                                    <WhiteSpace />
                                                </div>

                                            ))
                                    }
                                </div>
                            ))
                    }
                </div>
            </div>);
    }

}
